import { render } from "./BaseCard.vue?vue&type=template&id=06a55fdf&scoped=true&ts=true"
import script from "./BaseCard.vue?vue&type=script&lang=ts"
export * from "./BaseCard.vue?vue&type=script&lang=ts"

import "./BaseCard.vue?vue&type=style&index=0&id=06a55fdf&scoped=true&lang=scss"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a55fdf"]])

export default __exports__